// eslint:disable:jsx-no-lambda
import * as React from 'react';
import { SelectItem, SelectType } from '../types';
import { isMultiple } from '../select-type';

export interface OptionSelectMarkProps {
  item: SelectItem;
  isSelected: boolean;
  isDisabled?: boolean;
  selectType: SelectType;
  onSelect: (item: SelectItem) => void;
}

export class OptionSelectMark extends React.Component<OptionSelectMarkProps, any> {

  private handleOnChange = () => {
    this.props.onSelect(this.props.item);
  };

  private handleOnKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.charCode === 13) {
      this.props.onSelect(this.props.item);
    }
  };

  public render() {
    const {
      selectType,
      item: { value },
      isSelected,
      isDisabled
    } = this.props;
    return <input id={`select-option-${value}`}
      type={isMultiple(selectType) ? 'checkbox' : 'radio'}
      className="form-check-input visuallyhidden"
      checked={isSelected}
      disabled={isSelected && isDisabled}
      onChange={this.handleOnChange}
      name={`select-option-${value}`}
      onKeyPress={this.handleOnKeyPress}
    />;
  }
}
